module.exports = __webpack_public_path__ + "static/media/opa_thumb.d7db65cd.webp";